import axios from 'axios'

const state = {
  suggests: [],
}

const getters = {
  getSuggests (state) {
    return state.suggests
  },
}

const mutations = {
  setSuggests (state, payload) {
    state.suggests = payload
  },
}

const actions = {
  fetchNamesSuggestList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/suggestNamesList']}?name=${meta.name}&gender=${meta.gender}&count=${meta.count}`,
      )
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  fetchAddressSuggestList ({ commit, rootGetters }, meta) {
    return axios
      .get(`${rootGetters['api/suggestAddressList']}?address=${meta.address}`)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  /**
   * Получить подсказки городов(регионов)
   * @param {*} param0
   * @param {string} query
   */
  getSuggestCity ({ rootGetters }, { query }) {
    return axios
      .get(rootGetters['api/getSuggestCity'], {
        params: { query: query },
      })
      .then((res) => res.data.items)
  },
  /**
   * Получить подсказки улиц
   * @param {*} param0
   * @param {string} query
   */
  getSuggestStreetByCity ({ rootGetters }, { query, cityId = null }) {
    return axios
      .get(rootGetters['api/getSuggestStreetByCity'], {
        params: {
          query: query,
          cityId,
        },
      })
      .then((res) => res.data.items)
  },

  getSuggestStreetWithCity ({ rootGetters, dispatch }, { query, cityId = null }) {
    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/getSuggestStreetWithCity']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: { query },
        cancelToken: source.token,
      })
      .then((res) => res.data.items)
  },

  /**
   * Получить подсказки домов на улице
   * @param {*} param0
   * @param {string} address
   */
  getSuggestHouse ({ rootGetters, dispatch }, { query, streetId }) {
    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/getSuggestHouse']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })
    return axios
      .get(url, {
        params: { query: query, streetId: streetId },
        cancelToken: source.token,
      })
      .then((res) => res.data.items)
  },

  checkAddressIsDeliveryByString ({ rootGetters }, payload) {
    const params = {}
    if (payload.lat && payload.let) {
      params.lat = payload.lat
      params.let = payload.let
    } else {
      params.address = payload.address
    }
    return new Promise((resolve, reject) => {
      axios.get(rootGetters['api/checkAddressIsDeliveryByString'], {
        params,
      }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
